<template>
  <div :class="`${el}__bar`" :style="{ height: `${height}px` }">
    <div :class="`${el}__barProgress`" :style="{ height: `${percent}%` }" />
  </div>
</template>

<script>
export default {
  name: 'CareLevelModuleStatisticBar',
  props: {
    height: Number,
    percent: Number,
    el: String,
  },
};
</script>
